<template>

  <div ref="container" class="container-blackout" :class="{'container-blackout-white':white, 'opacity9':opacity9}"
       v-if="localShow">

    <div style="position: absolute; width: 100%; height: 100%; z-index: 1060; overflow: hidden;"
         class="d-flex flex-column justify-content-center align-content-center">

      <div v-if="busy"
           class="loader-wrapper align-self-center d-flex justify-content-center align-content-center mt-5">
        <div class="loader" style="scale: 1.5">
          <div class="ball-scale-multiple">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

      <transition name="slide-fade">

        <div v-if="!busy" class="d-flex flex-column justify-content-center align-content-center">

          <slot name="buttons-top">

            <div class="d-flex align-self-center p-1 mb-3">


              <slot name="buttons-top-appendage"></slot>

              <b-button variant="danger" @click="close">
                <b-icon-box-arrow-in-down-left/>
                Fechar
              </b-button>



            </div>

          </slot>


          <div class="d-flex align-self-center p-1">
            <slot></slot>
          </div>

          <slot name="buttons-bottom">

          </slot>

        </div>

      </transition>

    </div>

    <div class="blockUI blockOverlay"></div>


  </div>


</template>

<script>

export default {
  name: "t-blackout",
  data() {
    return {
      localShow: false,
    }
  },
  props: {
    busy: Boolean,
    value: Boolean,
    white: Boolean,
    opacity9: Boolean,
    noCloseOnEsc: Boolean,
  },
  created() {

    const escapeHandler = (e) => {
      if (e.key === 'Escape' && !this.noCloseOnEsc) {
        this.close()
      }
    }

    document.addEventListener('keydown', escapeHandler);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });

  },
  mounted() {
    this.localShow = this.value

  },
  computed: {},
  methods: {

    close() {
      this.$emit("onClose")
      this.localShow = false
      this.$emit("input", false)
    },

  },
  watch: {
    value(value) {
      this.localShow = value
    },
    localShow(value) {
      if (value)
        this.$emit("onOpen")
    },

  }

}
</script>

<style>
.container-blackout-white .blockOverlay {
  background-color: #FFFFFF;
}

.opacity9 .blockOverlay {
  opacity: 0.9;
}


.container-blackout {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1040; /*ATENÇÃO SE AUMENTAR AQUI DARÁ CONFLITO NO MOMENTO DE INSERIR IMAGENS DE EVOLUÇÃO COM O DIALOGO DA VISTORIA > EVOLUÇÃO > Detalhes da Foto*/
}
</style>